<template>
    <Dialog :open="open" @update:open="handleClose">
        <DialogContent class="sm:max-w-md">
            <DialogHeader>
                <DialogTitle>Edit Token</DialogTitle>
            </DialogHeader>

            <div>
                <Label for="token-name">Token Name</Label>
                <Input
                    id="token-name"
                    v-model="tokenName"
                    :placeholder="token.name"
                    class="mt-1.5"
                />
            </div>

            <DialogFooter class="mt-6">
                <Button variant="outline" @click="handleClose">
                    Cancel
                </Button>
                <Button
                    :disabled="!tokenName || tokenName === token.name"
                    @click="handleSave"
                >
                    Save changes
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { ref, PropType, watch } from 'vue';
import IToken from '@/types/Plugin/IToken';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const props = defineProps({
    open: {
        type: Boolean,
        required: true,
    },
    token: {
        type: Object as PropType<IToken>,
        required: true,
    },
});

const emit = defineEmits(['close', 'save', 'update:open']);

const tokenName = ref(props.token.name);

watch(
    () => props.open,
    (newValue) => {
        if (newValue) {
            tokenName.value = props.token.name;
        }
    }
);

const handleClose = () => {
    tokenName.value = props.token.name;
    emit('close');
    emit('update:open', false);
};

const handleSave = () => {
    if (tokenName.value && tokenName.value !== props.token.name) {
        emit('save', tokenName.value);
    }
};
</script>
